import './section-card.scss';

interface IProps {
  cardColor: string;
  title: string | React.ReactNode;
  headerChildren?: React.ReactNode;
  children: React.ReactNode;
  type?: 'independent' | 'dependent';
}

const SectionCard: React.FC<IProps> = ({
  cardColor,
  title,
  headerChildren,
  children,
  type = 'independent'
}) => {
  return (
    <div className={`section-card section-card--${type}`}>
      <div className="section-card__header">
        <h3 className="section-card__title">
          <span
            style={{ backgroundColor: cardColor }}
            className="section-card__indicator"
          ></span>
          {title}
        </h3>

        {headerChildren}
      </div>

      {children}
    </div>
  );
};

export default SectionCard;
